import React from 'react';
import PropTypes from 'prop-types';
import { Button, Input } from 'antd';
import { useTranslation } from 'react-i18next';

const PhdAddComment = ({ value, onChange, onSubmit, isSaving }) => {
  const { t } = useTranslation();
  const trimmed = value.trim();

  return (
    <div className="phd-thesis-detail__comment-form">
      <Input.TextArea
        value={value}
        onChange={event => onChange(event.target.value)}
        rows={4}
      />
      <div className="phd-thesis-detail__comment-actions">
        <Button
          type="primary"
          onClick={onSubmit}
          loading={isSaving}
          disabled={!trimmed}
        >
          {t('Uložiť')}
        </Button>
      </div>
    </div>
  );
};

PhdAddComment.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isSaving: PropTypes.bool,
};

PhdAddComment.defaultProps = {
  isSaving: false,
};

export default PhdAddComment;
